<p-dropdown [options]="languages" [(ngModel)]="selectedLanguage" optionLabel="label" (onChange)="onChangeLanguage($event)"></p-dropdown>
